module.exports = __webpack_public_path__ + "img/no_data.aedaa94b.png";